class CardVariantSwatches extends HTMLElement {
  constructor() {
    super();
    this.image = this.querySelector('.card__media img, .mb-pc__img--primary');
    this.price = this.querySelector('.price, .mb-pc__price');
    this.swatchesContainer = this.querySelector('[data-card-swatches]');
    if (!this.swatchesContainer) return;

    this.originalImageSrc = this.image ? this.image.getAttribute('src') : null;
    this.originalImageSrcset = this.image ? this.image.getAttribute('srcset') : null;
    this.originalPriceHTML = this.price ? this.price.innerHTML : null;
    this.originalPriceClasses = this.price ? this.price.className : null;

    this.swatchesContainer.addEventListener('mouseover', this.handlePointer.bind(this));
    this.swatchesContainer.addEventListener('focusin', this.handlePointer.bind(this));
    this.swatchesContainer.addEventListener('mouseleave', this.restore.bind(this));
    this.swatchesContainer.addEventListener('focusout', this.handleFocusOut.bind(this));
  }

  handlePointer(event) {
    const link = event.target.closest('.card__variant-swatch-link');
    if (!link) return;
    this.applyVariant(link);
  }

  handleFocusOut(event) {
    if (!this.swatchesContainer.contains(event.relatedTarget)) this.restore();
  }

  applyVariant(link) {
    const {
      variantImage,
      variantImageSrcset,
      variantPrice,
      variantComparePrice,
      variantAvailable,
    } = link.dataset;

    if (this.image) {
      if (variantImage) this.image.setAttribute('src', variantImage);
      if (variantImageSrcset) this.image.setAttribute('srcset', variantImageSrcset);
    }

    if (this.price && variantPrice) {
      const onSale = !!(variantComparePrice && variantComparePrice.length > 0);
      this.price.classList.toggle('price--on-sale', onSale);
      this.price.classList.toggle('price--sold-out', variantAvailable !== 'true');

      // Dawn card-product price markup
      const dawnRegular = this.price.querySelector('.price__regular .price-item--regular');
      if (dawnRegular) dawnRegular.textContent = variantPrice;
      const dawnSale = this.price.querySelector('.price__sale .price-item--sale');
      if (dawnSale) dawnSale.textContent = variantPrice;
      const dawnCompare = this.price.querySelector('.price__sale s.price-item--regular');
      if (dawnCompare && onSale) dawnCompare.textContent = variantComparePrice;

      // MyEbike mb-product-card price markup
      const mbPrice = this.price.querySelector('.mb-pc__p');
      if (mbPrice) {
        mbPrice.textContent = variantPrice;
        mbPrice.classList.toggle('is-sale', onSale);
      }
      const mbCompare = this.price.querySelector('.mb-pc__compare-price');
      if (mbCompare && onSale) mbCompare.textContent = variantComparePrice;
    }
  }

  restore() {
    if (this.image) {
      if (this.originalImageSrc != null) this.image.setAttribute('src', this.originalImageSrc);
      if (this.originalImageSrcset != null) this.image.setAttribute('srcset', this.originalImageSrcset);
    }
    if (this.price && this.originalPriceHTML != null) {
      this.price.className = this.originalPriceClasses;
      this.price.innerHTML = this.originalPriceHTML;
    }
  }
}

if (!customElements.get('card-variant-swatches')) {
  customElements.define('card-variant-swatches', CardVariantSwatches);
}
